export default __webpack_public_path__ + "static/media/small-mod2.59dc75ac.jpg";